import React from "react";
import {
  IconButton,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Radio,
  Typography,
} from "@mui/material";
import { useApp } from "context";
import { Helpers } from "utils";
import { IAppointment, IProvider } from "interfaces";
import { Progress } from "components";

type Props = {
  selected: boolean;
  item: IAppointment;
  onSelect: (appointmentId: number) => void;
};

export const Appointment = (props: Props) => {
  const { locale, service, t, theme } = useApp();
  const [provider, setProvider] = React.useState<IProvider>();

  function handleSelect(
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) {
    props.onSelect && props.onSelect(props.item.appointmentId);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      if (props.item.providerId) {
        const response = await service.provider.findById(props.item.providerId);
        setProvider(response);
      }
    };
    fetchData();
  }, [service.provider, props.item]);

  return (
    <>
      <ListItem disableGutters disablePadding dense>
        {
          <>
            <ListItemIcon>
              <Radio
                name="radio-appointments"
                onChange={handleSelect}
                checked={props.selected}
                value={props.item.appointmentId}
                sx={{ color: theme.palette.font.color }}
              />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  sx={{
                    fontSize: theme.font.md,
                    color: theme.palette.font.color,
                  }}
                >
                  {Helpers.toRelativeDate(
                    props.item.scheduledTime,
                    t.relative_date,
                    locale
                  )}
                </Typography>
              }
              secondary={
                provider ? (
                  <Typography
                    sx={{
                      fontSize: theme.font.sm,
                      color: theme.palette.font.accent,
                    }}
                  >
                    {Helpers.interpolate(
                      t.message.appointment.consult_provider,
                      {
                        name: Helpers.replaceComma(provider.username),
                      }
                    )}
                  </Typography>
                ) : null
              }
            />
          </>
        }
      </ListItem>
    </>
  );
};
